import React from 'react';
import './LocationSection.css';
import LocationBlock from './LocationBlock';

function LocationSection({ locations }) {
  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <div style={{ 
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      padding: '2rem 0'
    }}>
      <div style={{ 
        width: '100%',
        maxWidth: '600px',
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        alignItems: 'center',
        margin: '0 auto',
        padding: '0 20px'
      }}>
        {locations.map((location, index) => (
          <LocationBlock 
            key={index}
            title={location.title}
            city={location.city}
            venue={location.venue}
            time={location.time}
            mapUrl={location.mapUrl}
            icon={location.icon}
            mapButtonText={location.mapButtonText}
          />
        ))}
      </div>
    </div>
  );
}

export default LocationSection; 